import React from "react";
import Introduction from "@components/partnerWithUs/introduction";
import WhatWeDo from "@components/partnerWithUs/whatWeDo";
import Industries from "@components/partnerWithUs/industries";
import Form from "@components/partnerWithUs/form";
import { GetStaticPropsContext } from "next";
import MetaTags from "@components/shared/metaTags";
import initialCall from "@helpers/initial-call";
import { GQLDomains } from "@gql/types/gql";
import { useQuery } from "@tanstack/react-query";

import { getKeyWordsForMetaTags } from "@lib/sharedUtils";
import { getUrl } from "@helpers/switchLanguage";
import {
    ICustomDomain,
    Languages,
    TranslationsObject,
} from "@genericTypes/sharedTypes";
import { translate } from "@helpers/translationObjectFormatter";

const PartnerUsPage = () => {
    const { data: domainInfo } = useQuery<ICustomDomain, Error>({
        queryKey: ["domain"],
    });
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <>
            <MetaTags
                title={`${translate(
                    translations,
                    "several_siteMapPage_PartnerWithUs",
                )} | Several.com`}
                description={translate(
                    translations,
                    "several_partnerWithUsPage_meta_description",
                )}
                keyWords={
                    getKeyWordsForMetaTags(
                        domainInfo?.domain as GQLDomains,
                    ) as string
                }
                image={`${getUrl(
                    process.env.NEXT_PUBLIC_DEFAULT_LANG as Languages,
                    "/placeholder_several.jpg",
                )}`}
            />
            <section className="max-w-6xl mx-auto ">
                <h1 className="hidden">Partner With Us</h1>
                <Introduction />
                <WhatWeDo />
                <Industries />
                <Form />
            </section>
        </>
    );
};

export const getStaticProps = async (ctx: GetStaticPropsContext) => {
    return await initialCall("PartnerWithUs", ctx);
};
export default PartnerUsPage;
